import React from 'react' 


export const Avatar = ({source}) => {
    const [avatar, setAvatar] = React.useState(undefined) 
    const [preview, setPreview] = React.useState( source ||'/assets/images/faces/default.svg')

    const handle = (e) => {
        if (!e.target.files || e.target.files.length === 0) {
            setAvatar(undefined)
            return
        }
        setAvatar(e.target.files[0])
    }
  
    React.useEffect(()=>{
        let reader  = new FileReader();
        if (avatar && avatar?.type.match('image.*')) {
            reader.readAsDataURL(avatar);
        } 
        reader.onloadend = () => setPreview(reader.result) 

    },[avatar])

      
    return (
        <div className="cover-photo">
            <h4 className="title">Choose image</h4>
            <div>
              
                {preview && <img src={preview} alt="user avatar" /> }

                {!preview &&  <img src="/faces/default.svg" alt="user avatar" />}
                <label htmlFor="photo" className="btn-label">Change</label>
                <input 
                    type="file"  
                    className="hidden" 
                    id="photo"
                    name="avatar"
                    onChange={handle}
                />
            </div>
        </div>
    )
} 
